module.exports = __webpack_public_path__ + "static/media/expand-wide.f956f817.svg";